import { fetch as fetchPolyfill } from 'whatwg-fetch'
import { api } from '../endpoint'
import { Cluster } from '../types'

const CHILI_PIPER_CLUSTER = 'CHILI_PIPER_CLUSTER'
const VERSION = '2.0'
export const CLUSTER_ENDPOINT_URL = api('/api/v1/match-cluster/')
let requestPromise: Promise<string> | null = null
const setCluster = (cluster: Cluster) => {
  try {
    const data = { value: cluster, timestamp: new Date().getTime(), version: VERSION }
    window.localStorage.setItem(CHILI_PIPER_CLUSTER, JSON.stringify(data))
  } catch (err) {
    console.error('error set cluster')
  }
}
const isExpired = (timestamp: number, days = 1) => {
  // return new Date().getTime() - timestamp > 1000 * 60 * 60 * 24 * days
  return true
}
export const fetchCluster = (tenantDomain = '') => {
  const url = `${CLUSTER_ENDPOINT_URL}${tenantDomain}`
  if (!requestPromise) {
    requestPromise = fetchPolyfill(url)
      .then(response => response.json())
      .then(response => {
        setCluster(response?.clusterPrefix || '')
        return response?.clusterPrefix || ''
      })
      .catch(() => {
        console.error('error CLUSTER request')
        return ''
      })
  }
  return requestPromise
}
export const getCluster = (tenantDomain: string) => {
  try {
    const cluster = JSON.parse(window.localStorage.getItem(CHILI_PIPER_CLUSTER) || '{}') as Cluster
    if (
      cluster &&
      cluster.timestamp &&
      !isExpired(cluster.timestamp, 1) &&
      cluster.version === VERSION
    ) {
      requestPromise = null
      return Promise.resolve(cluster.value)
    }
  } catch (error) {
    console.error(error)
  }
  return fetchCluster(tenantDomain)
}
